import React from "react";
import classnames from "classnames";
import Element from "src/components/base/element";

interface IProps {
    className?: string;
    children: React.ReactNode;
    hoverable?: boolean;
}

function List(props: IProps) {
    const { className, children, hoverable, ...rest } = props;
    return (
        <Element
            {...rest}
            className={classnames("list", className, {
                ["is-hoverable"]: hoverable,
            })}
        >
            {children}
        </Element>
    );
}

export default List;
